import React from "react";

const Logo = ({ className, tabIndex, onClick }) => {
    return <h1 className={`menu__title pb-2 lg:pb-3 font-bold text-white text-6xl md:text-5xl lg:text-8xl cursor-pointer font-outfit ${className}`} tabIndex={tabIndex} onClick={onClick}>tijmen.</h1>
};

export default Logo;